export default __webpack_public_path__ + "static/76-2d374420041d98633d5d08ab4fb111b6.svg";